import React from 'react';

import Logo from 'components/Common/Logo/Logo';

import styles from './CheckoutHeader.module.scss';

export default function CheckoutHeader(): JSX.Element {
  return (
    <header className={styles.header}>
      <Logo classes={{ container: styles.logoContainer }} />
    </header>
  );
}
